import { ERROR_CODE } from '../enum/errors_code.enum';

export interface IApiError {
  code: string;
  message: string;
  timestamp?: string;
}

export const ERROR_MESSAGES: Record<string, string> = {
  S200: 'Thành công',
  E202_AUTH: 'Đầu vào không hợp lệ.',
  E203_AUTH: 'Dịch vụ không phản hồi.',
  E279_AUTH: 'Email không trùng khớp với tài khoản của bạn. Vui lòng thử lại.',
  E208_AUTH: 'Tên đăng nhập hoặc số điện thoại không tồn tại trên hệ thống. Vui lòng thử lại.',
  E278_AUTH: 'Mã OTP đã hết hiệu lực',
  E277_AUTH: 'Gửi OTP thất bại',
  E214_AUTH: 'Tài khoản bị khóa do đổi mật khẩu sai quá nhiều lần. Vui lòng thử lại sau',
  E280_AUTH: 'Bạn đã yêu cầu OTP quá nhiều lần trong thời gian ngắn. Vui lòng thử lại sau.',
  E282_AUTH:
    'Chức năng đã bị khóa do vượt quá số lần xác thực OTP được cho phép. Vui lòng thử lại sau.',
  E210_AUTH: 'Mật khẩu hiện tại không chính xác',
  E217_AUTH:
    'Phiên xác thực của bạn đã hết hạn sau 10 phút. Vui lòng xác thực lại để tiếp tục đặt mật khẩu mới.',
  OTP_410: 'Bạn đã gửi OTP quá nhiều lần trong thời gian ngắn. Vui lòng thử lại sau',
  OTP_409: 'Mã OTP không hợp lệ. Vui lòng kiểm tra lại',
  OTP_407: 'Tài khoản của bạn đã bị khóa do nhập sai OTP quá nhiều lần',
  OTP_413: 'Mã OTP đã hết hiệu lực',
  OTP_411: 'Bạn đã gửi OTP quá nhiều lần. Vui lòng thử lại sau',
  OTP_412: 'OTP đã bị khóa. Vui lòng thử lại sau',
  DEFAULT: 'Đã có lỗi xảy ra. Vui lòng thử lại sau',
};

export const SILENT_ERROR_CODES = [
  ERROR_CODE.E214_AUTH,
  ERROR_CODE.E217_AUTH,
  ERROR_CODE.OTP_410,
  ERROR_CODE.OTP_411,
  ERROR_CODE.OTP_412,
  ERROR_CODE.OTP_409,
  ERROR_CODE.OTP_413,
  ERROR_CODE.E210_AUTH,
  ERROR_CODE.E216_AUTH,
];
export const handleApiError = (error: IApiError): string => {
  const errorCode = error?.code;
  const errorMessage = error?.message;
  return ERROR_MESSAGES[errorCode] || errorMessage || ERROR_MESSAGES.DEFAULT;
};

export const isSilentError = (errorCode: ERROR_CODE): boolean => {
  return SILENT_ERROR_CODES.includes(errorCode);
};
